import { Component, Input, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FlexDirective, LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { CachedRepositoryService } from "@tylertech/core-module";
import { Utilities } from "@tylertech/shared-module";
import { ICardMetadata } from "@tylertech/tyler-api-types";
import { AugmentedModelObject, RepositoryFormData } from "../../interfaces";
import { MetadataEventService, MetadataService } from "../../services";
import { MetadataCardEditComponent } from "./metadataCard.edit.component";
import { MetadataCardViewComponent } from "./metadataCard.view.component";

@Component({
    selector: "card-metadata",
    templateUrl: "./card.metadata.tmpl.html",
    imports: [
        FlexDirective,
        LayoutAlignDirective,
        LayoutDirective,
        MetadataCardEditComponent,
        MetadataCardViewComponent,
    ]
})
export class CardMetadataComponent implements OnInit
{
    private $metadataService = inject(MetadataService);
    private $metadataEventService = inject(MetadataEventService);
    private $repositoryService = inject(CachedRepositoryService);

    @Input()
    cardMetadata: ICardMetadata;

    @Input()
    viewOnly: boolean;

    @Input()
    model: AugmentedModelObject;

    @Input()
    datacontroller: RepositoryFormData;

    @Input()
    dense: boolean;

    loading: boolean = false;

    editMode: boolean = false;

    constructor()
    {
        this.$metadataEventService.onLoadCardMetadata.pipe(takeUntilDestroyed()).subscribe(() => this.onMetadataUpdate());
    }

    ngOnInit(): void
    {
        this.onMetadataUpdate();
    }

    private onMetadataUpdate(): void
    {
        if (Utilities.IsNullOrUndefined(this.cardMetadata) || this.loading || !this.model)
            return;
        if (this.viewOnly)
            this.cardMetadata.CanEdit = false;
        const self = this;
        this.loading = true;
        setTimeout(() =>
        {
            if (self.cardMetadata.ViewMetaData)
                self.$metadataService.VerifyLoadChildren(self.cardMetadata.ViewMetaData.Properties, self.cardMetadata.ViewMetaData.TypeName, this.model)
                    .finally(() =>
                    {
                        self.loading = false;
                    });
            else
                self.loading = false;
        }, 50);
    }

    toggleEditMode(): void
    {
        this.editMode = !this.editMode;
        console.log(this);
        console.log(this.editMode);
    }

    onSave(): void
    {
        const self = this;
        self.$repositoryService
            .Save({
                Item1: self.cardMetadata.ViewMetaData.TypeName,
                Item2: Utilities.stringify(self.model),
            })
            .finally(() =>
            {
                self.toggleEditMode();
                self.onMetadataUpdate();
            });
    }
}
